<template>
  <div class="container container--language">
    <div class="language__items" v-show="!this.$store.state.showPromoData">
      <div class="language__item first" @click="openLangList()" @keydown.esc="closeLangList">
        <img src="../assets/images/world.png"/>
        <div class="language">{{ this.$store.state.countryName }}</div>
      </div>
      <div class="language--list" v-show="showLangList">
        <ul>
          <li
              v-for="(country, i) in this.$store.state.countryList" :key="i"
              @click="setLang(country.key, country.country)">
            {{ country.country }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Language',
  data() {
    return {
      showLangList: false
    }
  },
  created() {
    console.log(this.$store.state.country);
  },
  methods: {
    setLang(country, name) {
      this.showLangList = false;
      this.$store.commit('resetAll');
      this.$store.commit('setCountry', country);
      this.$store.commit('setCountryName', name);
    },
    openLangList() {
      this.showLangList = !this.showLangList;
    },
    closeLangList() {
      this.showLangList = false;
    },
    handleClickOutside (evt) {
      if (!this.$el.contains(evt.target)) {
        this.closeLangList()
      }
    },
    handleEscPressed (evt) {
      if (evt.keyCode === 27){
        this.closeLangList()
      }
    }

  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('keyup', this.handleEscPressed);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>